export default "__VITE_ASSET__CpiewOkg__"